$(function () {
  const cookieName = 'whatsapp_first_load'
  const chatClosedCookieName = 'whatsapp_chat_closed'

  const setPersistentCookie = (name, value, hours) => {
    const date = new Date()
    date.setTime(date.getTime() + hours * 60 * 60 * 1000)
    document.cookie = name + '=' + value + '; expires=' + date.toUTCString() + '; path=/'
  }

  const getCookie = name => {
    const cookies = document.cookie.split(';')
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim()
      if (cookie.startsWith(name + '=')) {
        return cookie.substring(name.length + 1)
      }
    }
    return null
  }

  const firstLoadTime = getCookie(cookieName)
  const chatClosed = getCookie(chatClosedCookieName)

  if (!firstLoadTime) {
    setPersistentCookie(cookieName, new Date().getTime(), 48)
  } else {
    const currentTime = new Date().getTime()
    const elapsedTime = currentTime - parseInt(firstLoadTime)

    if (elapsedTime > 48 * 60 * 60 * 1000) {
      return
    }
  }

  const ffShowWhattsappChat = () => {
    document.removeEventListener('scroll', ffShowWhattsappChat)
    setTimeout(() => {
      if (!chatClosed) {
        $('.js-whatsapp__chat').show()
      }
    }, $('.js-whatsapp__chat').data('ff-show-countdown'))
  }

  document.addEventListener('scroll', ffShowWhattsappChat)

  $('.js-whatsapp__bubble').on('click', () => {
    setPersistentCookie(chatClosedCookieName, '', -1)
    $('.js-whatsapp__chat').show()
  })

  $('.js-whatsapp__close-chat').on('click', () => {
    setPersistentCookie(chatClosedCookieName, 'true', 30)
    $('.js-whatsapp__chat').hide()
  })

  $(document).on('click', event => {
    if (!$(event.target).closest('.js-whatsapp__chat, .js-whatsapp__bubble').length) {
      $('.js-whatsapp__chat').hide()
    }
  })
})
